import httpClient, { requestData } from '../httpClient';

export const getAnalyticsSummary = (derasarId) =>
  requestData(httpClient.get('/analytics/summary', { params: { derasarId } }));

export const getAnalyticsLog = (derasarId, params = {}) =>
  requestData(httpClient.get('/analytics/log', { params: { derasarId, ...params } }));

export const getSuperAdminAnalyticsSummary = () =>
  requestData(httpClient.get('/super-admin/analytics/summary'));

export const getSuperAdminAnalyticsLog = (params = {}) =>
  requestData(httpClient.get('/super-admin/analytics/log', { params }));
